import { frontendURL } from '../../../helper/URLHelper';

import PilotPageRouteView from './pages/PilotPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';

import AssistantSettingsIndex from './assistants/settings/Settings.vue';
import AssistantOverviewIndex from './assistants/overview/Index.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import CustomToolsIndex from './tools/Index.vue';
import BuiltinToolsIndex from './builtinTools/Index.vue';
import UpdateContactConfig from './builtinTools/UpdateContactConfig.vue';
import KnowledgeBasesIndex from './knowledgeBases/Index.vue';
import KnowledgeBasesShow from './knowledgeBases/Show.vue';
import AddFaqs from './faqs/Add.vue';
import EditFaq from './faqs/Edit.vue';
import ImportFaqExcel from './faqs/ImportExcel.vue';
import FileUpload from './knowledgeBases/documents/FileUpload.vue';
import UniversalWechatCrawl from './knowledgeBases/documents/UniversalWechatCrawl.vue';
import WebCrawl from './knowledgeBases/documents/WebCrawl.vue';
import WechatCrawl from './knowledgeBases/documents/WechatCrawl.vue';
import MipSync from './knowledgeBases/documents/MipSync.vue';
import PendingFaqsIndex from './pendingFaqs/Index.vue';
import AssistantConfigPage from './config/Index.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const assistantRoutes = [
  // Config Page (配置页面)
  {
    path: frontendURL('accounts/:accountId/pilot/:assistantId/config'),
    component: AssistantConfigPage,
    name: 'pilot_assistant_config',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/pilot/:assistantId/config/:section'),
    component: AssistantConfigPage,
    name: 'pilot_assistant_config_section',
    meta,
  },
  // Legacy routes (保留旧路由)
  {
    path: frontendURL('accounts/:accountId/pilot/:assistantId/overview'),
    component: AssistantOverviewIndex,
    name: 'pilot_assistants_overview_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/pilot/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'pilot_tools_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/pilot/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'pilot_assistants_scenarios_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/pilot/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'pilot_assistants_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/pilot/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'pilot_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/pilot/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'pilot_assistants_settings_index',
    meta,
  },
  // Settings sub-pages (guardrails and guidelines)
  {
    path: frontendURL(
      'accounts/:accountId/pilot/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'pilot_assistants_guardrails_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/pilot/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'pilot_assistants_guidelines_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/pilot/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'pilot_assistants_create_index',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/pilot/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'pilot_assistants_index',
    meta,
  },
  // Knowledge Bases
  {
    path: frontendURL('accounts/:accountId/pilot/knowledge_bases'),
    component: KnowledgeBasesIndex,
    name: 'pilot_knowledge_bases_index',
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/pilot/knowledge_bases/:id'),
    component: KnowledgeBasesShow,
    name: 'pilot_knowledge_bases_show',
    redirect: to => ({
      name: 'pilot_knowledge_bases_documents',
      params: { id: to.params.id },
    }),
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/:id/documents'
    ),
    component: KnowledgeBasesShow,
    name: 'pilot_knowledge_bases_documents',
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/pilot/knowledge_bases/:id/faqs'),
    component: KnowledgeBasesShow,
    name: 'pilot_knowledge_bases_faqs',
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/pilot/knowledge_bases/:id/recall_test'),
    component: KnowledgeBasesShow,
    name: 'pilot_knowledge_bases_recall_test',
    meta: {
      permissions: ['administrator'],
    },
  },
  // 全局公众号抓取（无需指定知识库）
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/documents/wechat/crawl'
    ),
    component: UniversalWechatCrawl,
    name: 'pilot_global_documents_wechat_crawl',
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/documents/wechat/crawl/:page'
    ),
    component: UniversalWechatCrawl,
    name: 'pilot_global_documents_wechat_crawl_page',
    meta: {
      permissions: ['administrator'],
    },
  },
  // 知识库内文档上传
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/:id/documents/file/upload'
    ),
    component: FileUpload,
    name: 'pilot_documents_file_upload',
    meta: {
      permissions: ['administrator'],
    },
  },
  // 抓取网页
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/:id/documents/web/crawl'
    ),
    component: WebCrawl,
    name: 'pilot_documents_web_crawl',
    meta: {
      permissions: ['administrator'],
    },
  },
  // 抓取公众号
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/:id/documents/wechat/crawl'
    ),
    component: WechatCrawl,
    name: 'pilot_documents_wechat_crawl',
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/:id/documents/wechat/crawl/:page'
    ),
    component: WechatCrawl,
    name: 'pilot_documents_wechat_crawl_page',
    meta: {
      permissions: ['administrator'],
    },
  },
  // 同步营销云
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/:id/documents/mip/sync'
    ),
    component: MipSync,
    name: 'pilot_documents_mip_sync',
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/pilot/knowledge_bases/:id/faqs/add'),
    component: AddFaqs,
    name: 'pilot_faqs_add',
    meta: {
      permissions: ['administrator'],
    },
  },
  // FAQ Excel 导入
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/:id/faqs/upload'
    ),
    component: ImportFaqExcel,
    name: 'pilot_faqs_upload',
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/pilot/knowledge_bases/:knowledgeBaseId/faqs/:faqId/edit'
    ),
    component: EditFaq,
    name: 'pilot_faqs_edit',
    meta: {
      permissions: ['administrator'],
    },
  },
  // Pending FAQs (待审核 FAQ)
  {
    path: frontendURL('accounts/:accountId/pilot/pending_faqs'),
    component: PendingFaqsIndex,
    name: 'pilot_pending_faqs_index',
    redirect: to => ({
      name: 'pilot_pending_faqs_status',
      params: { status: 'pending' },
    }),
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/pilot/pending_faqs/:status'),
    component: PendingFaqsIndex,
    name: 'pilot_pending_faqs_status',
    meta: {
      permissions: ['administrator'],
    },
  },
  // Custom Tools
  {
    path: frontendURL('accounts/:accountId/pilot/custom_tools'),
    component: CustomToolsIndex,
    name: 'pilot_custom_tools_index',
    meta: {
      permissions: ['administrator'],
    },
  },
  // Builtin Tools
  {
    path: frontendURL('accounts/:accountId/pilot/builtin_tools'),
    component: BuiltinToolsIndex,
    name: 'pilot_builtin_tools_index',
    meta: {
      permissions: ['administrator'],
    },
  },
  // Update Contact Tool Config
  {
    path: frontendURL(
      'accounts/:accountId/pilot/builtin_tools/update_contact/config'
    ),
    component: UpdateContactConfig,
    name: 'pilot_builtin_tools_update_contact_config',
    meta: {
      permissions: ['administrator'],
    },
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/pilot'),
    component: PilotPageRouteView,
    redirect: to => {
      return {
        name: 'pilot_assistants_index',
        params: {
          navigationPath: 'pilot_assistants_overview_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
